import script from "./Personas.vue?vue&type=script&setup=true&lang=js"
export * from "./Personas.vue?vue&type=script&setup=true&lang=js"

import "./Personas.vue?vue&type=style&index=0&id=4b8ffff0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8ffff0"]])

export default __exports__